import type { FC } from 'react'
import styled from 'styled-components'

import CancelRequest from '@/components/DocumentRequests/CancelRequest'
import H6 from '@/components/H6'
import LoadingSpinner from '@/components/LoadingSpinner'
import UnexpectedError from '@/components/UnexpectedError'
import { useGetDocumentRequestActivityFeedQuery } from '@/lib/apollo/query/get-document-request-activity-feed'
import type { DocumentRequest } from '@/lib/apollo/query/get-document-requests'
import { parseDate, toDateLabel } from '@/utils/date'

interface Props {
  customerId: string
  applicationId: string
  subjectId: string
  documentRequest: DocumentRequest
}

const Container = styled.div`
  display: grid;
  gap: 20px;
`

const ActivityContainer = styled.div`
  display: grid;
  gap: 10px;
  align-items: start;
`

const UL = styled.ul`
  display: grid;
  gap: 20px;
`

const ExpandedDocumentRequest: FC<Props> = ({
  customerId,
  applicationId,
  subjectId,
  documentRequest,
}) => {
  const { loading, error, data, refetch } = useGetDocumentRequestActivityFeedQuery({
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
    variables: {
      customerId: customerId,
      applicationId: applicationId,
      subjectId: subjectId,
      recommendationId: documentRequest.id,
    },
  })

  return (
    <Container>
      {!documentRequest.completed && (
        <div>
          <CancelRequest
            customerId={customerId}
            applicationId={applicationId}
            subjectId={subjectId}
            recommendationId={documentRequest.id}
          />
        </div>
      )}
      <div>
        <H6>Email request body</H6>
        <em>{documentRequest.requestMessage}</em>
      </div>
      <div>
        <H6>History</H6>
        {loading ? (
          <LoadingSpinner size="1x" />
        ) : error ? (
          <UnexpectedError error={error} onRetry={() => refetch()} />
        ) : (
          <UL>
            {data?.getDocumentRequestActivityFeed.length === 0 ? (
              <p>No further history.</p>
            ) : (
              data?.getDocumentRequestActivityFeed.map((activity, i) => (
                <li key={i}>
                  <ActivityContainer>
                    <div>
                      <strong>{activity.details}</strong>
                    </div>

                    <div>{activity.message}</div>
                    <div className="side-by-side-flex-end">
                      Actioned by {activity.author} on{' '}
                      {toDateLabel({
                        date: parseDate(activity.createdAt),
                        dateFormat: 'dd/MM/yyyy HH:mm:ss',
                      })}
                    </div>
                  </ActivityContainer>
                </li>
              ))
            )}
          </UL>
        )}
      </div>
    </Container>
  )
}

export default ExpandedDocumentRequest
